import type { SharedRendererState } from "@rosette/web_components/src/game/SharedRendererState.js";
import { useRune } from "@rosette/react_utils/src/useRune.js";
import { AnalysisBar } from "@rosette/web_components/src/game/analysis/AnalysisBar.js";
import { PlayerType } from "@rosette/ts/src/royalur/model/PlayerType.js";


interface PerfectGameMetadataProps {
    lwps?: number[];
    winner?: PlayerType;
    sharedRendererState: SharedRendererState;
}


export function PerfectGameMetadata({ lwps, winner, sharedRendererState }: PerfectGameMetadataProps) {
    const moveIndex = useRune(sharedRendererState.currentMoveIndex);
    let currentLWP: number | undefined = lwps ? lwps[moveIndex] : undefined;
    if (lwps !== undefined && winner !== undefined && moveIndex + 2 >= lwps.length) {
        currentLWP = (winner === PlayerType.LIGHT ? 100 : 0);
    }
    return (
        <div>
            <p className="mt-0 mb-0 px-2 pb-1 text-sm text-subtle text-left transition-opacity duration-300 ease-in-out">
                ⏷ Light&apos;s real-time chance of winning
            </p>

            <AnalysisBar
                lwp={currentLWP}
                orientation="horizontal" />
        </div>
    );
}
